module.exports = __webpack_public_path__ + "img/z8.065f3ba1.png";